import type { Observer } from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import type AbstractSubject from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import GTMOverviewFilterPaneCloseModel from '../../../gtm/models/GTMOverviewFilterPaneCloseModel';
import GTMOverviewFilterPaneOpenModel from '../../../gtm/models/GTMOverviewFilterPaneOpenModel';
import GTM from '../../../gtm/GTM';
import searchEvents from '../../../events/searchEvents';
import ModalComponent from '../../shared/components/ModalComponent';
import HouseSearchListItems from '../store/HouseSearchListItems';

export default class SearchMapFiltersModal extends ModalComponent implements Observer {
    constructor(context: ContextInterface) {
        super(context);

        this.keepModalInBackground = true;
    }

    public update(subject: AbstractSubject): void {
        if (!(subject instanceof HouseSearchListItems)) return;

        this.#updateSearchButtonWithResultsCount(subject.total);
    }

    protected onTemplateInstantiation(modalTemplate: HTMLTemplateElement): void {
        super.onTemplateInstantiation(modalTemplate);
        this.setEventListeners();
    }

    protected onModalOpened(): void {
        GTM.track(GTMOverviewFilterPaneOpenModel.parseToGTMData({ location: 'map' }));
    }

    protected onModalClosed(): void {
        GTM.track(GTMOverviewFilterPaneCloseModel.parseToGTMData({ location: 'map' }));
    }

    private setEventListeners(): void {
        document.addEventListener(searchEvents.updateSearchMap, () => {
            this.#listenForFormChanges();
        });

        HouseSearchListItems.getInstance().attach(this);
    }

    #listenForFormChanges(): void {
        if (!this.modalElement) {
            return;
        }

        const form: HTMLFormElement | null = this.modalElement?.querySelector('form');
        if (form === null) {
            return;
        }

        const mainForm: HTMLFormElement | null = document.querySelector('form[name="search"]');
        const fields: HTMLInputElement[] = Array.from(form.querySelectorAll('input'));

        if (mainForm === null) {
            return;
        }

        fields.forEach((field: HTMLInputElement) => {
            field.addEventListener('change', () => {
                const mainField: HTMLInputElement | null = mainForm.querySelector(`
                    [data-name="${field.dataset.name}"][data-facet-name="${field.dataset.facetName}"]
                `);

                if (mainField === null) {
                    return;
                }

                mainField.checked = field.checked;
                mainField.dispatchEvent(new Event('change'));
            });
        });
    }

    #updateSearchButtonWithResultsCount(totalHouses: number): void {
        if (!this.modalElement) {
            return;
        }

        const searchButton: HTMLSpanElement | null = this.modalElement.querySelector(
            'button[data-results-counter] > span'
        );

        if (searchButton === null) {
            return;
        }

        searchButton.innerText = totalHouses.toString();
    }

    static getClassName(): string {
        return 'SearchMapFiltersModal';
    }
}
